import React, { FC } from 'react';
import { TabsPanel } from 'snacks-design-system';

interface componentProps {
  children: React.ReactNode;
  isSelected?: boolean;
  id: string;
}

const PIETabsPanel: FC<componentProps> = (props: componentProps) => {
  return <TabsPanel {...props}>{props.children}</TabsPanel>;
};

export default PIETabsPanel;
